<template>
  <button
    title="filter"
    type="button"
    class="flex"
    @click="onToggleFilter"
  >
    <svg-vue icon="filter-solid" title="Filter" class="w-9 h-9 fill-salesium-red" />
  </button>
</template>

<script>
export default {
    methods: {
        onToggleFilter() {
            this.$emit('toggleFilter');
        },
    },
};
</script>